import PropTypes from 'prop-types';

export function resourceShape(resourceType) {
  return PropTypes.shape({
    type: PropTypes.oneOf(
      Array.isArray(resourceType) ? resourceType : [resourceType],
    ).isRequired,
  });
}

export function resourcesAsResourceMap({ resourceTypes, resources }) {
  const resourceMap = resourceTypes.reduce((accumulator, resourceType) => {
    accumulator[resourceType] = {};
    return accumulator;
  }, {});

  resources?.forEach((resource) => {
    if (resourceMap[resource.type]) {
      resourceMap[resource.type][resource.id] = resource;
    }
  });

  return resourceMap;
}
